import { render, staticRenderFns } from "./loko_location_modal.vue?vue&type=template&id=5dbdad92&scoped=true&"
import script from "./loko_location_modal.vue?vue&type=script&lang=js&"
export * from "./loko_location_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbdad92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dbdad92')) {
      api.createRecord('5dbdad92', component.options)
    } else {
      api.reload('5dbdad92', component.options)
    }
    module.hot.accept("./loko_location_modal.vue?vue&type=template&id=5dbdad92&scoped=true&", function () {
      api.rerender('5dbdad92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/loko/location/loko_location_modal.vue"
export default component.exports